import React from "react";
import "../../styles/Home-page-component/solutions.css";

const SolutionsSection = () => {
  return (
    <section className="solutions-section">
      <div className="container">

        <h2 className="section-title">
          Core Solutions
        </h2>

        <div className="solutions-grid">

          <div className="solution-card">
            <div className="card-icon">🤖</div>
            <h3>AI-powered SaaS</h3>
            <p>
              Intelligent software solutions that scale with your business needs
            </p>
          </div>

          <div className="solution-card">
            <div className="card-icon">⚙️</div>
            <h3>Human-Centric Engineering</h3>
            <p>
              Expert engineering teams augmented with AI capabilities
            </p>
          </div>

          <div className="solution-card">
            <div className="card-icon">☁️</div>
            <h3>Cloud Architecture</h3>
            <p>
              Scalable cloud solutions on AWS, Azure, and GCP
            </p>
          </div>

          <div className="solution-card">
            <div className="card-icon">🔧</div>
            <h3>Custom Development</h3>
            <p>
              Tailored enterprise solutions built for scale
            </p>
          </div>

        </div>

      </div>
    </section>
  );
};

export default SolutionsSection;